import { render } from "./FormularioRegistro.vue?vue&type=template&id=375a7ec8&ts=true"
import script from "./FormularioRegistro.vue?vue&type=script&lang=ts"
export * from "./FormularioRegistro.vue?vue&type=script&lang=ts"

import "./FormularioRegistro.vue?vue&type=style&index=0&id=375a7ec8&lang=scss"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__